export default __webpack_public_path__ + "static/media/logo.d549b294.png";